<template>
  <div class="w-full">
    <div class="mt-10 max-w-4xl mx-auto" v-if="config.reviews">
      <div class="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
        <div class="md:grid md:grid-cols-3 md:gap-6">
          <div class="md:col-span-1">
            <h3 class="text-lg font-medium leading-6 text-gray-900">
              Automated review requests
            </h3>
            <p class="mt-1 text-sm leading-5 text-gray-500">
              We will be sending review requests based on the settings
            </p>
            <div class="mt-4">
              <a
                target="_blank"
                class="text-blue-600 text-md "
                href="https://configs.carthike.com/images/looxsampleimage.png"
                >Click to view sample Message</a
              >
            </div>
          </div>
          <div class="mt-5 md:mt-0 md:col-span-2">
            <form @submit="handleSubmit">
              <fieldset>
                <legend class="text-base leading-6 font-medium text-gray-900">
                  Enable automation
                </legend>

                <div class="mt-4 flex flex-wrap">
                  <VSwitch
                    :value="config.reviews.isEnabled"
                    @input="handleSwitch"
                  />
                </div>
                <p class="mt-2 text-sm text-gray-500">
                  Automated WhatsApp messages are sent from our approved
                  WhatsApp Business API number.
                </p>
              </fieldset>
              <div class="grid grid-cols-3 gap-6 mt-5">
                <div class="col-span-3 sm:col-span-2">
                  <div>
                    <label
                      for="phone_number"
                      class="block text-sm font-medium leading-5 text-gray-700"
                    >
                      Phone Number
                    </label>
                    <div class="mt-1 relative rounded-md shadow-sm">
                      <vue-tel-input
                        :value="phoneNumber"
                        mode="international"
                        @input="handlePhoneNumberUpdate"
                      />
                      <p class="mt-2 text-sm text-gray-500">
                        We will share this number as a link where customers can
                        reply to you if they have any concerns.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-span-3 sm:col-span-2">
                  <div>
                    <label
                      for="company-website"
                      class="block text-sm font-medium text-gray-700"
                    >
                      Review request timing
                    </label>
                    <div class="mt-1 flex rounded-md shadow-sm">
                      <input
                        type="text"
                        name="company-website"
                        id="company-website"
                        class="flex-1 min-w-0 block w-full px-3 py-2 rounded-none rounded-l-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 border"
                        placeholder="number between 1 - 70"
                        v-model="config.reviews.sendAfterDays"
                      />
                      <select
                        class="inline-flex items-center px-3 rounded-r-md border border-l-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm"
                        v-model="config.reviews.sendAfter"
                      >
                        <option value="order_created"
                          >days after order created</option
                        >
                        <option value="order_fulfilled"
                          >days after order fulfilled</option
                        >
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div class="grid grid-cols-3 gap-6 mt-5">
                <div class="col-span-3 sm:col-span-2">
                  <label
                    for="location"
                    class="block text-sm leading-5 font-medium text-gray-700"
                    >Language</label
                  >
                  <select
                    id="location"
                    class="mt-1 form-select block w-full pl-3 pr-10 py-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                    v-model="config.reviews.messageLanguage"
                  >
                    <option
                      v-for="(language, index) in templates"
                      :key="index"
                      :value="language.elementName"
                      >{{ language.name }}</option
                    >
                  </select>
                </div>
              </div>
              <div class="mt-6">
                <label
                  for="about"
                  class="block text-sm leading-5 font-medium text-gray-700"
                >
                  Message
                </label>
                <div class="rounded-md shadow-sm">
                  <textarea
                    id="about"
                    rows="8"
                    class="form-textarea mt-1 block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5 cursor-not-allowed bg-gray-100"
                    :value="currentTemplate"
                    :disabled="true"
                  ></textarea>
                </div>
              </div>
              <div class="mt-4 sm:mt-0 sm:col-span-2">
                <div class="mt-8 border-t border-gray-200 pt-5">
                  <div class="flex justify-end">
                    <span class="ml-3 inline-flex rounded-md shadow-sm">
                      <button
                        type="submit"
                        class="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out"
                        @click="save"
                      >
                        Save
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <Notification :text="notificationText" :show="showNotification" />
      </div>
      <OptinOnboarding :title="optinTitle" />
    </div>
  </div>
</template>

<script>
import { VueTelInput } from "vue-tel-input";
import VSwitch from "../../../components/Common/VSwitch";

import Notification from "../../../components/Common/Notification";

import OptinOnboarding from "../../../components/Common/OptinOnboarding";

export default {
  name: "AutomatedConfigureForm",
  components: {
    VueTelInput,
    VSwitch,
    Notification,
    OptinOnboarding
  },

  data() {
    return {
      phoneNumber: "",
      notificationText: "",
      showNotification: false,
      config: {},
      templates: [],
      showModal: false,
      optinTitle:
        "Get more reviews by collecting WhatsApp opt-in from Checkout page (Mandatory)"
    };
  },
  computed: {
    currentTemplate() {
      const template = this.templates.find(
        template => template.elementName === this.config.reviews.messageLanguage
      );
      if (template && template.variables) {
        for (const variable of template.variables) {
          template.message = template.message.replace(
            variable.variable,
            variable.replacingElement
          );
        }
      }

      return template?.message;
    },
    discountUrl() {
      const { shopOrigin } = this.$store.getters.getStore;
      return `https://${shopOrigin}/admin/discounts/`;
    }
  },
  created() {
    this.init();
    this.updateOnboadingFlag();
  },
  mounted() {},
  methods: {
    init() {
      this.isLoading = true;
      this.$store.dispatch("getAutomationConfig").then(response => {
        this.config = response.config;
        this.templates = response.reviewTemplates;
        this.phoneNumber = this.config.phoneNumber;
        this.isLoading = false;
      });
    },
    handleSubmit(event) {
      event.preventDefault();

      console.log(this.phoneNumber);
    },
    handlePhoneNumberUpdate(phoneNumber, { number, isValid, country }) {
      if (isValid) {
        console.log(number, isValid, country);
        this.config.phoneNumber = number.e164;
      }
    },
    save() {
      if (this.hasMoreCharacters) {
        alert("Button Label should be less than 12 characters");
        return;
      }
      this.updateConfig();
    },
    handleSwitch(value) {
      this.config.reviews.isEnabled = value;
    },
    updateConfig() {
      const automationConfig = { ...this.config };
      this.$store
        .dispatch("updateAutomationConfig", { requestParams: automationConfig })
        .then(() => {
          this.displayNotification("settings updated");
        });
    },
    displayNotification(text) {
      this.showNotification = true;
      this.notificationText = text;
      setTimeout(() => {
        this.showNotification = false;
      }, 3000);
    },
    openOptinModal() {
      this.showModal = true;
    },
    updateOnboadingFlag() {
      this.$store.dispatch("updateOnboardingFlag", {
        requestParams: {
          flag: "isLooxIntegrationVisited"
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
